import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
    // subClassId_: "1010101",//获取当前subclassid
    // objId_: "20000",//获取当前objId
    // classId_: "10101",

    subClassId_: "", //获取当前subclassid
    objId_: "", //获取当前objId
    classId_: "",

    objectId: {
      id: "",
      classId: "",
      subClassId: "",
    },

    listName: "",
    change_info: {
      changeId: "0",
      changeClassId: "0",
      changeSubClassId: "0",
    },
    search_value: {
      id: "",
      val: "",
    },
    changeChartsDetail: {},
    tabPageInfo: [],

    activedTabInHome: "", //主页面中，当前的激活的tab名字。
    showingTabsInHome: [],

    tabIndex: 0,
    routeLink: false,

    tableId_1: 1,
    tableId_2: 2,
    tableId_3: 3,

    listId: "", //系统管理的列表id
    listName: "", //listId相应的name

    quickCreate: {}, //

    menuList: [], //首页左侧的主菜单

    recentVistObject: {
      //当前最近访问对象
      baseClassId: "",
      number: "",
      id: "",
    },

    myFavoriteObject: {
      //当前收藏对象
      baseClassId: "",
      number: "",
      id: "",
    },

    pswUserId: {
      id: "",
      name: "",
    },

    personalSearch: {
      //当前个人搜索
      id: "",
      name: "",
      type: "",
    },

    ProcessLength: 0,

    changeWorkflowStatus: 0, //保存变更当前工作流状态

    reloadTabPage: 1, //项目tab页面操作刷新page页下一个状态的属性
    reloadProjectBtnDisable: true, //项目中如果该项目为暂停或者取消，禁止一切操作
    AllProjectBtnDisable: true, //项目点击为暂停或者取消，禁止按钮操作

    isProjectAdmin: false, //是否为项目负责人
    isProjectDirector: false, //是否为项目经理
    isProjectExecuters: false, //是否为项目执行者
    isSuperAdmin: false, //是否为超级管理员
    projectCreatedBy: "", //跟项目创建者id
    swiftLogo: 0, //监听swiftlogo设置同步更新
    calendarList: [],

    isItemTitleBlockImg: "", //redline取缩略图是否为redline或者item
    redLineTitleBlockImg: {}, //redline取缩略图的change信息

    includesList: ["abc"],

    getTreeReload: 0,
    records: [],

    urlList: [
      {
        id: 101,
        url: "/item",
      },
      {
        id: 104,
        url: "/changePage",
      },
      {
        id: 105,
        url: "/manufactPage",
      },
      {
        id: 106,
        url: "/manufactPartPage",
      },
      {
        id: 901,
        url: "/UserItem",
      },
      {
        id: 902,
        url: "/UserGroupItem",
      },
      {
        id: 401,
        url: "/quality",
      },
      {
        id: 301,
        url: "/project",
      },
      {
        id: 501,
        url: "/technology",
      },
      {
        id: 502,
        url: "/resource",
      },
    ],

    lastVisitList: [],
    refresh: 0,

    boms_table_id: 0,
    tabInfo: {},

    pageChanged: false,
    menuData: {},

    copyItems: [],
    dragMenu: null,
    setSaveSearch: 0,
    projectRootId: "",
    userList: [],
    showUserName: "",
    delInfo: {},
    searchTable: {},
  },
  mutations: {
    setUserList(state, data) {
      state.userList = [...data];
    },
    setTabIndex: (state, data) => {
      const { index = "", row = "", secIndex = "", relRow = "", ...obj } = data;
      state.showingTabsInHome.forEach((i) => {
        const { name } = i;
        // const { id, classId, subClassId } = obj;
        const checkObj = { ...state.objectId, ...obj };
        const { id, classId, subClassId } = checkObj;
        const n = "" + id + classId + subClassId;


        if (name.indexOf(n) != -1) {
          i.index = index || i.index;
          if (index === 0) {
            i.index = 0;
          }
          i.row = row || i.row;
          i.secIndex = secIndex || i.secIndex;
          i.relRow = relRow || i.relRow;
        }
      });
      // state.showingTabsInHome.find((i) => {
      //   const { name } = i;
      //   const { id, classId, subClassId } = obj;
      //   const n = "" + id + classId + subClassId;
      //   return name.indexOf(n) != -1;
      // }).index = index;
    },

    setProjectRootId: (state, data) => {
      state.projectRootId = data;
    },
    saveSearch: (state) => {
      state.setSaveSearch++;
    },
    SET_DRAG_MENU: (state, data) => {
      state.dragMenu = data;
    },
    setProcessLength(state, data) {
      state.ProcessLength = data;
    },
    setRecords(state, data) {
      state.records = data.map((i) => i.itemId).join(",");
    },

    menuClick(state, data) {
      state.menuData = { num: Date.parse(new Date()), ...data };
    },

    setPageChanged(state, data) {
      state.pageChanged = data.isChanged;
      if (data.isChanged) {
        state.includesList.push(data.name);
        state.includesList = [...new Set(state.includesList)];
      } else {
        // state.includesList.pop();
        state.includesList = state.includesList.filter((i) => i !== data.name);
      }
    },

    setCopyItems(state, data) {
      state.copyItems = [...data];
    },

    setObjectId(state, data) {
      for (const i in data) {
        data[i] = +data[i];
      }
      state.objectId = { ...data };
      // state.objectId.id = Number(data.id);
      // state.objectId.classId = Number(data.classId);
      // state.objectId.subClassId = Number(data.subClassId);
    },
    setShowUserName(state, data) {
      state.showUserName = data;
    },
    getReloadTree(state) {
      state.getTreeReload++;
    },
    setTabInfo(state, data) {
      state.tabInfo = { ...data };
    },
    setPageRefresh(state, data) {
      state.refresh++;
    },
    setItemTitleBlockImg(state, obj) {
      //redline取缩略图的change信息
      state.isItemTitleBlockImg = obj;
      if (obj == "isItem" || obj == "isProject") {
        state.redLineTitleBlockImg = {};
      } else {
        state.redLineTitleBlockImg = obj.changeInfo;
      }
    },
    setAllProjectBtnDisable(state, Boolean) {
      if (Boolean) {
        state.AllProjectBtnDisable = false;
      } else {
        state.AllProjectBtnDisable = true;
      }
    },
    setReloadProjectBtnDisable(state, Boolean) {
      if (Boolean) {
        state.reloadProjectBtnDisable = false;
      } else {
        state.reloadProjectBtnDisable = true;
      }
    },
    setIsProjectAdmin(state, num) {
      if (num == -1) {
        state.isProjectAdmin = false;
      } else {
        state.isProjectAdmin = true;
      }
    },
    setIsProjectDirector(state, num) {
      if (num == -1) {
        state.isProjectDirector = false;
      } else {
        state.isProjectDirector = true;
      }
    },
    setIsProjectExecuters(state, num) {
      if (num == -1) {
        state.isProjectExecuters = false;
      } else {
        state.isProjectExecuters = true;
      }
    },
    setReloadTabPage(state) {
      state.reloadTabPage += 1;
    },
    setUserInfo(state, userInfo) {
      localStorage.setItem("userInfo", JSON.stringify(userInfo)); //将传递的数据先保存到localStorage中
      state.userInfo = userInfo; // 之后才是修改state中的状态
    },
    setListName(state, name) {
      state.listName = name; //
    },
    setQuickCreate(state, val) {
      state.quickCreate = val; //
    },
    setClassId(state, name) {
      state.classId_ = name; //
    },
    setSubClassId(state, num) {
      state.subClassId_ = num; //
    },
    setObjID(state, num) {
      state.objId_ = num; //
    },
    setTabID(state, index) {
      state.tabPageInfo = index; //
    },
    setListId(state, num) {
      state.listId = num; //
    },
    setListName(state, name) {
      state.listName = name; //
    },
    setChangeInfo(state, num) {
      state.change_info.changeId = num.id; //
      state.change_info.changeClassId = num.classId; //
      state.change_info.changeSubClassId = num.subClassId; //
    },
    setChangeInfo2(state, num) {
      state.change_info.changeId = num.changeId; //
      state.change_info.changeClassId = num.changeClassId; //
      state.change_info.changeSubClassId = num.changeSubClassId; //
    },

    setChangeChartsDetail(state, num) {
      state.changeChartsDetail = num; //
    },
    setEditTabsData(state, data) {
      state.editableTabsData.push(data);
    },
    setActivedTabInHome(state, tabName) {
      state.activedTabInHome = tabName; //
    },
    setShowingTabsInHome(state, tab) {
      state.showingTabsInHome.push(tab); //在页签组中添加新的页签
    },
    clearShowingTabsInHome(state) {
      state.showingTabsInHome = [];
    },
    replaceShowingTabsInHome(state, tabs) {
      //用新的页签组代替老的页签组
      state.showingTabsInHome = tabs;
    },
    setChangeWorkflowStatus(state, data) {
      //保存变更当前工作流状态
      state.changeWorkflowStatus = data;
    },

    setIncludesList(state, data) {
      state.includesList.push(data);
      state.includesList = [...new Set(state.includesList)];
    },
    getIncludesListPop(state, data) {
      state.includesList = state.includesList.filter((i) => i !== data);
    },

    setLastVisitList(state, list) {
      // state.lastVisitList = [...list];
      const item = state.menuList.find((i) => i.id == 104);
      item.children[1].children = [...list];
    },

    replaceTabNameTitleInShowingTabsInHome(state, obj) {
      //修改当前tab name and title
      let oldTabs = state.showingTabsInHome;
      let newTabs = [];
      for (let i = 0; i < oldTabs.length; i++) {
        if (oldTabs[i].name == obj.oldName) {
          let tab = oldTabs[i];
          tab.name = obj.newName;
          tab.title = obj.newName;
          newTabs.push(tab);
        } else {
          newTabs.push(oldTabs[i]);
        }
      }
      state.showingTabsInHome = newTabs;
      state.activedTabInHome = obj.newName;
    },

    pushMyFavoriteIntoMenuList(state, obj) {
      //将收藏的对象添加到收藏列表中
      var object = {
        children: [],
        icon: "",
        id: obj.id,
        name: obj.number,
        order: "",
        parentId: "",
        perms: "",
        type: obj.baseClassId,
        url: state.urlList.find((i) => i.id == obj.baseClassId).url,
      };
      for (var i = 0; i < state.menuList.length; i++) {
        if (state.menuList[i].id == 104) {
          let oldFavorite = state.menuList[i].children[0].children;
          for (var j = 0; j < oldFavorite.length; j++) {
            if (
              oldFavorite[j].name == object.name &&
              oldFavorite[j].type == object.type
            )
              return; //
          }
          var newFavorite = [];
          if (oldFavorite.length === 30) {
            newFavorite.push(object);
            for (var j = 0; j < 9; j++) {
              if (
                oldFavorite[j].id == object.id &&
                oldFavorite[j].type == object.type &&
                oldFavorite[j].name != object.name
              ) {
                continue;
              }
              newFavorite.push(oldFavorite[j]);
            }
          } else if (oldFavorite.length < 30) {
            newFavorite.push(object);
            for (var j = 0; j < oldFavorite.length; j++) {
              if (
                oldFavorite[j].id == object.id &&
                oldFavorite[j].type == object.type &&
                oldFavorite[j].name != object.name
              ) {
                continue;
              }
              newFavorite.push(oldFavorite[j]);
            }
          }
          state.menuList[i].children[0].children = newFavorite;
        }
      }

      // state.menuList.push(object);
    },
    removeMyFavoriteIntoMenuList(state, obj) {
      //将收藏的对象取消收藏
      for (var i = 0; i < state.menuList.length; i++) {
        if (state.menuList[i].id == 104) {
          let oldFavorite = state.menuList[i].children[0].children;
          var newFavorite = [];
          for (var j = 0; j < oldFavorite.length; j++) {
            if (
              oldFavorite[j].id == obj.id &&
              oldFavorite[j].type == obj.baseClassId
            ) {
            } else {
              newFavorite.push(oldFavorite[j]);
            }
          }
          state.menuList[i].children[0].children = newFavorite;
        }
      }

      // state.menuList.push(object);
    },

    setMenuList(state, manus) {
      //登录时将从后端载入的菜单载入
      state.menuList = manus;
    },
    setRecentVistObject(state, object) {
      state.recentVistObject.baseClassId = object.baseClassId; //
      state.recentVistObject.number = object.number; //
      state.recentVistObject.id = object.id; //
    },
    setMyFavoriteObject(state, object) {
      state.myFavoriteObject.baseClassId = object.baseClassId; //
      state.myFavoriteObject.number = object.number; //
      state.myFavoriteObject.id = object.id; //
    },
    setPersonalSearch(state, object) {
      state.personalSearch.id = object.id; //
      state.personalSearch.name = object.name; //
      state.personalSearch.type = object.type; //
    },
    setUserNewPsd(state, obj) {
      state.pswUserId = obj; //
    },
    setCalendar(state, obj) {
      state.calendarList = obj;
    },
    setIsSuperAdmin(state, obj) {
      state.isSuperAdmin = obj;
    },
    setProjectCreatedBy(state, obj) {
      state.projectCreatedBy = obj;
    },
    setBomsTableId(state, obj) {
      state.boms_table_id = obj;
    },
    setSwiftLogo(state, obj) {
      if (obj == "1") {
        state.swiftLogo += 1;
      }
    },
    setTabList(state, data) {

      const { rootId = 0, idList = [], subClassId = 0, parentId } = data;

      const arr = [];

      if (rootId) {
        state.showingTabsInHome.map(i => {
          const { query, rootId: rId } = i

          if (rId == rootId) {
            arr.push(i)
          }
          if (query?.id == rootId) {
            arr.push(i)
          }


        })
      }
      if (idList.length) {
        state.showingTabsInHome.map(i => {
          const { query, rootId: rId } = i

          if (idList.includes(query?.id)) {
            arr.push(i)
          }
        })
      }

      const xx = arr.map(i => i.name)
      state.showingTabsInHome = state.showingTabsInHome.filter(i => !xx.includes(i.name));



      // state.showingTabsInHome = arr;



    },
  },
  getters: {
    getCopyItems(state) {
      return state.copyItems;
    },
    getActivedTabInHome(state) {
      return state.activedTabInHome;
    },
    getShowingTabInHome(state) {

      return state.showingTabsInHome;
    },
    getMenuList(state) {
      return state.menuList;
    },
    getRecentVistObject(state) {
      return state.recentVistObject;
    },
    getMyFavoriteObject(state) {
      return state.myFavoriteObject;
    },
    getPersonalSearch(state) {
      return state.personalSearch;
    },
    ifExistingInMyFavorit(state) {
      var obj = state.myFavoriteObject;
      for (var i = 0; i < state.menuList.length; i++) {
        if (state.menuList[i].id == 104) {
          let oldFavorite = state.menuList[i].children[0].children;
          for (var j = 0; j < oldFavorite.length; j++) {
            if (
              oldFavorite[j].id == obj.id &&
              oldFavorite[j].type == obj.baseClassId
            ) {
              return 1; //
            }
          }
        }
      }
    },
    ifExistingInRecentVistObject(state) {
      var obj = state.recentVistObject;
      for (var i = 0; i < state.menuList.length; i++) {
        if (state.menuList[i].id == 104) {
          let oldRecentVistObject = state.menuList[i].children[1].children;
          for (var j = 0; j < oldRecentVistObject.length; j++) {
            if (
              oldRecentVistObject[j].name == obj.number &&
              oldRecentVistObject[j].type == obj.baseClassId
            ) {
              return 1; //
            }
          }
        }
      }
    },
    ifExistingInPersonalSearch(state) {
      var obj = state.personalSearch;
      for (var i = 0; i < state.menuList.length; i++) {
        if (state.menuList[i].id == 104) {
          let oldPersonalSearch = state.menuList[i].children[2].children;
          for (var j = 0; j < oldPersonalSearch.length; j++) {
            if (oldPersonalSearch[j].name == obj.name) {
              return 1; //
            }
          }
        }
      }
    },
    getSearchSeek() { },
  },
  actions: {
    async setRecentList({ commit, state }, obj) {
      const { data } = await axios.post("/pmdm/search/saveMarkedObject", obj);
      commit("setLastVisitList", data.object.markList);
    },
    delPro({ commit, state }, data) {
      commit("setTabList", data);
      const item = state.showingTabsInHome.at(-1);
      commit("setActivedTabInHome", item.name)

      // state.delInfo = data;
    },
    filterTabs({ commit, state }, data) {
      commit("setTabList", data);
      // state.delInfo = data;
    },
    setTabItem({ commit, state }, data) {
      let item = state.showingTabsInHome.find(i => i?.name === data.name)
      if (!item) {
        // state.showingTabsInHome.push(data)
        commit("setShowingTabsInHome", data)
      }
      item = data
      commit("setActivedTabInHome", data.name)
    }

    // async setSearchInfo({ commit, state }, data) {
    //   const { id: baseClassId, val: value } = data;



    //   // state.search_value.id = num.id; //
    //   // state.search_value.val = num.val; //
    // },
  },
  modules: {},
});
export default store;
